// Ubicación en el repo: src/components/BrandFormModal.jsx
// Modal Crear/Editar marca de producto (Fase A del módulo de Inventario/
// Contabilidad, migración 0046, 24-ago-2026). Mismo patrón que
// CategoryFormModal — un solo campo.
import { useState } from 'react';
import { createBrand, updateBrand } from '../lib/brands';

export default function BrandFormModal({ brand, onClose, onSaved }) {
  const isEdit = !!brand;
  const [name, setName] = useState(brand?.name ?? '');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    if (!name.trim()) {
      setError('El nombre es obligatorio.');
      return;
    }
    setSaving(true);
    try {
      if (isEdit) {
        await updateBrand(brand.id, name);
      } else {
        await createBrand(name);
      }
      onSaved();
    } catch (err) {
      if (err.code === '23505') {
        setError('Ya existe una marca activa con ese nombre.');
      } else {
        setError(err.message || 'No se pudo guardar la marca.');
      }
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className="modal-overlay">
      <div className="modal-card">
        <h2>{isEdit ? 'Editar marca' : 'Nueva marca'}</h2>
        <form onSubmit={handleSubmit} className="patient-form">
          <label className="field">
            <span>Nombre *</span>
            <input value={name} onChange={(e) => setName(e.target.value)} autoFocus placeholder="Ej: Phonak" />
            <span className="field-hint">Se guarda en mayúsculas.</span>
          </label>
          {error && <p className="auth-error">{error}</p>}
          <div className="modal-actions">
            <button type="button" className="button-secondary" onClick={onClose} disabled={saving}>
              Cancelar
            </button>
            <button type="submit" className="button-primary" disabled={saving}>
              {saving ? 'Guardando…' : 'Guardar'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
